import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import NProgress from 'nprogress'
import storage from 'store'
import { ACCESS_TOKEN } from '@store/mutation-types.js'
import store from '@store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  NProgress.start()

  if (to.query.auth) {
    localStorage.setItem('auth_key', to.query.auth)
    next(to.path)
  } else {
    next()
  }

  if (to.path === '/login') {
    next()
  } else {
    const token = storage.get(ACCESS_TOKEN)
    if (token == null || token == '') {
      next({ name: 'login' })
    } else {
      store
        .dispatch('GetInfo')
        .then((r) => {
          console.log(r)
          next()
        })
        .catch((err) => {
          next()
        })
    }
  }
})

router.afterEach((to) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)
  let title = ''
  if (nearestWithTitle) title = nearestWithTitle.meta.title

  document.title = title

  NProgress.done()
})

export default router
